module.exports = __webpack_public_path__ + "img/1-3.159d4a87.png";